import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Section, EmptyState } from "@/components/ui-kit";
import { Mail, Zap, Hand } from "lucide-react";

const CANAL_COLORS = {
  "Client": "bg-blue-50 text-blue-700 border-blue-200",
  "Promoteur / Dossier": "bg-purple-50 text-purple-700 border-purple-200",
};

export default function EmailHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/emails/history").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = items.filter((x) =>
    filter === "all" ? true : filter === "manuel" ? x.mode === "Manuel" : x.mode === "Automatique"
  );

  const fmtDate = (d) => {
    if (!d) return "—";
    try { return new Date(d).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
    catch { return d; }
  };

  return (
    <div className="p-8" data-testid="email-history-page">
      <PageHeader title="Historique des emails" subtitle="Tous les emails envoyés — manuels et automatiques" />

      <div className="flex gap-2 mb-5">
        {[["all", "Tous"], ["manuel", "Manuels"], ["auto", "Automatiques"]].map(([k, label]) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`filter-${k}`}
            className={`px-4 py-2 text-sm rounded-sm border transition-colors ${filter === k ? "bg-[#111111] text-white border-[#111111]" : "bg-white text-slate-600 border-slate-300 hover:border-slate-400"}`}>
            {label}
          </button>
        ))}
        <div className="ml-auto flex items-center text-sm text-slate-400">{filtered.length} email(s)</div>
      </div>

      <Section title="Emails envoyés">
        {loading ? (
          <div className="p-8 text-center text-slate-400">Chargement…</div>
        ) : filtered.length === 0 ? (
          <EmptyState icon={Mail} title="Aucun email" description="Les emails envoyés apparaîtront ici." testid="email-history-empty" />
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[10px] uppercase tracking-wider text-slate-500 border-b border-slate-200 bg-slate-50">
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3">Canal</th>
                  <th className="px-4 py-3">Type</th>
                  <th className="px-4 py-3">Destinataire</th>
                  <th className="px-4 py-3">Sujet</th>
                  <th className="px-4 py-3">Mode</th>
                  <th className="px-4 py-3">Par</th>
                </tr>
              </thead>
              <tbody data-testid="email-history-table">
                {filtered.map((e, i) => (
                  <tr key={i} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`email-row-${i}`}>
                    <td className="px-4 py-3 whitespace-nowrap text-slate-600">{fmtDate(e.date)}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-block px-2 py-0.5 text-xs rounded-full border ${CANAL_COLORS[e.canal] || "bg-slate-50 text-slate-600 border-slate-200"}`}>{e.canal}</span>
                    </td>
                    <td className="px-4 py-3 font-medium">{e.type}</td>
                    <td className="px-4 py-3 text-slate-600">{e.destinataire}</td>
                    <td className="px-4 py-3 text-slate-600 max-w-xs truncate" title={e.sujet}>{e.sujet}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center gap-1 text-xs font-medium ${e.mode === "Automatique" ? "text-amber-600" : "text-emerald-600"}`}>
                        {e.mode === "Automatique" ? <Zap className="w-3 h-3" /> : <Hand className="w-3 h-3" />}{e.mode}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-slate-500">{e.envoye_par}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Section>
    </div>
  );
}
